// extracted by mini-css-extract-plugin
module.exports = {"Loader_fixed":"Loader_Loader_fixed__19wk6","Loader_absolute":"Loader_Loader_absolute__2GYgg","Loader_static":"Loader_Loader_static__3VJ4R"};